import React, { useMemo, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Typography, useMediaQuery, useTheme } from '@mui/material'

import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Box from '@mui/material/Box'
import LinkIcon from '@mui/icons-material/Link'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import { useSelector } from 'react-redux'

function ListOperations({ fetchOperations, operations, setSelectedRows, setOperations }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const siteUser = useSelector((store) => store.user)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const [modifiedColumns, setModifiedColumns] = useState([])

  // LAP-733 (GE022): columns memoized so headerName re-evaluates on locale change
  const columns = useMemo(() => [
    // { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'date',
      headerName: t('tempsTravail.headerDate'),
      width: 130,
      valueGetter: (params) => `${params.row.date}`,
    },
    {
      field: 'start_time',
      headerName: t('tempsTravail.headerStartTime'),
      width: 130,
      renderCell: (params) => params.row.start_time,
    },
    {
      field: 'end_time',
      headerName: t('tempsTravail.headerEndTime'),
      width: 200,
      renderCell: (params) => params.row.end_time,
    },
    {
      field: 'activity_type',
      headerName: t('tempsTravail.headerActivityType'),
      width: 199,
    },
    {
      field: 'job',
      headerName: t('tempsTravail.headerJob'),
      type: 'date',
      width: 350,
      renderCell: (params) => `${params.row.job?.Name} - ${params.row.job?.entreprise?.Name}`,
      // valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.Datedimport),
    },
    {
      field: 'customer',
      headerName: t('tempsTravail.headerClient'),
      type: 'date',
      width: 190,
    },

    {
      field: 'total_hours',
      headerName: t('tempsTravail.headerTotalHours'),
      width: 140,
    },
  ], [t])

  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }

  return (
    <div
      style={{
        width: '100%',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {t('tempsTravail.titleDays') /* LAP-733 (GE022) */} ({operations.count})
      </Typography>
      <DataGrid
        sx={{
          height: 800,
          fontSize: isMobile ? '11px' : '13px',
          '.dtcell': { alignItems: 'flex-start' },
        }}
        rows={operations.results ? operations.results : []}
        columns={columns}
        getRowHeight={() => (isMobile ? 'auto' : 50)}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
        disableSelectionOnClick
      />
    </div>
  )
}
export default ListOperations
